export enum CheckboxType {
  Primary = 'Primary',
  Alternative = 'Alternative',
  AlternativeBordered = 'AlternativeBordered',
}
